<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import { href } from "../../../utils/Constant/Constant";
    import {gridClass} from "../../../store"
    import Link from "svelte-link";
    const handleGrid=(getvalue:boolean)=>{
      gridClass.update(value => value = getvalue)
    }
    export let header:string
</script>

<h6 class="mb-0">{header}</h6>
<ul>
  <li>
    <Link class="grid-bookmark-view" {href} on:click={() => handleGrid(false)}>
      <FeatherIcon icon="grid" />
    </Link>
  </li>
  <li>
    <Link class="list-layout-view" {href} on:click={() => handleGrid(true)}>
      <FeatherIcon icon="list" />
    </Link>
  </li>
</ul>
